<script>
export default {
  name: 'MenuItem',
  props: ['text', 'icon', 'route', 'beta'],
  methods: {
    getImgUrl(pet) {
      var images = require.context('../../assets/icons/', false, /\.png$/)
      return images('./' + pet + ".png")
    }
  },
}
</script>


<template>
    <router-link class="link" :to= route>
        <!-- <img :src="icon"> -->
        <img class="link__icon" :src="getImgUrl(icon)" >
        <div class="link__text">{{ text }}<sup v-if="beta" class="link__text__beta"> BETA</sup></div>
        <div class="link__arrow"><img src="../../assets/icons/baseline_chevron_right_white_48dp.png"></div>
    </router-link>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.link{
    display: flex;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;
    border-radius: 5px;
    padding: 2px 0 2px 5px;
    text-decoration: none;
    color: $menuTextColor;

    &:visited{
      color: $menuTextColor;
    }

    &:hover{
      background-color: rgba(200,200,200,0.2);
    }

    &.router-link-active{
      background-color: rgba(200,200,200,0.2);
    }

    &__icon{
        height: 30px;
        width: 30px;
        // border-radius: 50px;
        // border: solid 2px white;
        margin-right: 25px;
    }

    &__text{
        margin-right: 15px;
        @include myFont();
        font-size: 16px;
        font-weight: 300;
        width: 80%;

        &__beta{
          font-size: 11px;
        }
    }

    &__arrow{
      & img{
        position: relative;
        top: 2px;
        height: 25px;
      }
    }
}

@media (max-width: 1699px){
  .link{
    &__text{display: none;}
    &__arrow{display: none;}
  }
}

</style>
